import React from "react";
import ErrorPage from "../../Components/ErrorPage/ErrorPage";

const Error = () => {
  return (
    <div>
      <ErrorPage />
    </div>
  );
};

export default Error;
